// extracted by mini-css-extract-plugin
export default {"formitem":"AntdFormItem_formitem__q5gax"};